export const IGNORED_SENTRY_ERRORS = [
  'Non-Error promise rejection captured',
  /Object captured as promise rejection with keys/,
];
// The only auth-bearing header this app sends (see api/HttpClient.ts).
// Denied from Sentry's `dataCollection.httpHeaders` so bearer tokens never leave the browser.
export const SENSITIVE_HEADERS = ['authorization'];
